import { LocaleMessages } from "vue-i18n";

// prettier-ignore
const translations: LocaleMessages = {
  nl: {
    manuals: {
      menuItems: {
        manuals: "Bibliotheek"
      }
    }
  }
};

export default translations;
